import { Box, Flex, Text } from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { COMMON_WEB_PATH, COMMON_WEB_PATH_JP } from "../../../constant";
import { REPLACE_AIR } from "../../../replace_str_constant";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useCheckLogin from "../../../hook/useCheckLogin";
import { CloseMenu, notice } from "../../../redux/action/action";
import useDeviceType from "../../../hook/useDeviceType";
import { getRankingList } from "../../../api/getApi";
import { formatNumber } from "../../../utils/formatNumber";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { special2TextGradientStyle } from "../../../utils/specialTextGradientStyle";
import RankingNumberCount from "./RankingNumberCount";
import useGames from "../../../pages/Game/useGames";

const rank_config = {
  1: {
    color: "#158399",
  },
  2: {
    color: "#AE2F80",
  },
  3: {
    color: "#E66700",
  },
  4: {
    color: "#5D4ABC",
  },
  5: {
    color: "#FF7C7C",
  },
  6: {
    color: "#B76FB3",
  },
  7: {
    color: "#B76FB3",
  },
  8: {
    color: "#B76FB3",
  },
  9: {
    color: "#B76FB3",
  },
  10: {
    color: "#B76FB3",
  },
};

const TopGameBoard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const splideRef = useRef();

  const [rankingList, setRankingList] = useState([]);

  const isMobile = useDeviceType() === "Mobile";
  const dispatch = useDispatch();
  const { isLogin } = useCheckLogin();
  const navigate = useNavigate();

  const { handlePlayGame } = useGames();

  const handleEnterGame = useCallback(
    (gameItem) => {
      const { platform, game_name_en, game_uid } = gameItem || {};
      handlePlayGame({
        gameName: game_name_en,
        gamePlatform: platform,
        gameUid: game_uid,
      });
    },
    [handlePlayGame],
  );

  useEffect(() => {
    if (window?.profit_ranking_status === 1) {
      getRankingList({
        paramsData: {
          limit: 10,
        },
      }).then((data) => {
        const result = data?.data;

        const topTen = result.slice(0, 10);
        setRankingList(topTen);
      });
    }
  }, []);
  return (
    <>
      <Box>
        <Splide
          ref={splideRef}
          options={{
            pagination: false,
            arrows: false,
            drag: "free",
            // perPage: 2,
            // perMove: 1,
            fixedWidth: "255px",
            fixedHeight: "110px",
            gap: "30px",
            lazyLoad: "nearby",
            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
            breakpoints: {
              768: {
                fixedWidth: "200px",
                fixedHeight: "90px",
                gap: "15px",
              },
            },
          }}
        >
          {rankingList?.map((item, index) => {
            const { platform, game_code, profit } = item;
            return (
              <SplideSlide>
                <Box
                  //bg={boxBg}
                  bgImage={`url(${COMMON_WEB_PATH}/theOne/ranking/ranking_${
                    index + 1
                  }.png)`}
                  bgSize="100% 100%"
                  bgPos="center"
                  sx={{
                    backgroundPositionX: "-15px",
                  }}
                  bgRepeat="no-repeat"
                  display={"flex"}
                  h="100%"
                  // h={{
                  //   base: "40px",
                  // }}
                  alignItems={"flex-start"}
                  gap="10px"
                  cursor={"pointer"}
                  onClick={() => handleEnterGame(item)}
                  justifyContent={"flex-start"}
                  position="relative"
                  pr={{
                    base: "42px",
                    md: "50px",
                  }}
                  pl={{
                    base: "68px",
                    md: "95px",
                  }}
                  pt={{
                    base: "24px",
                    md: "30px",
                  }}
                  pb={{
                    base: "13px",
                    md: "20px",
                  }}
                >
                  <Box
                    alignItems={"center"}
                    display="flex"
                    gap="5px"
                    overflow={"hidden"}
                    h="100%"
                  >
                    <Box display="flex" flexDirection={"column"}>
                      <Flex
                        h={{
                          base: "30px",
                          md: "37px",
                        }}
                        alignItems={"center"}
                      >
                        <Text
                          sx={{
                            ...special2TextGradientStyle,
                            WebkitTextStroke: `1px ${
                              rank_config[index + 1]?.color
                            }`,
                            textStroke: `1px ${rank_config[index + 1]?.color}`,
                          }}
                          className="text-overflow"
                          fontSize={{
                            base: "15px",
                            md: "20px",
                          }}
                          fontWeight={700}
                          color="white"
                        >
                          {item?.[`game_name_en`] || "-"}
                        </Text>
                      </Flex>
                      <Flex
                        fontSize={{
                          base: "17px",
                          md: "22px",
                        }}
                        color="#fff"
                        alignItems={"center"}
                        gap="2.5px"
                        fontWeight={700}
                        flex={1}
                      >
                        {/* <Icon color="#fff" as={RiUserFill} /> */}

                        <Text
                          sx={{
                            ...special2TextGradientStyle,
                            WebkitTextStroke: `1px ${
                              rank_config[index + 1]?.color
                            }`,
                            textStroke: `1px ${rank_config[index + 1]?.color}`,
                          }}
                        >
                          {" "}
                          <RankingNumberCount value={profit} />
                        </Text>
                      </Flex>
                    </Box>
                  </Box>
                  <Box
                    position="absolute"
                    top="12px"
                    right={{
                      base: "-27px",
                      md: "-45px",
                    }}
                    bgImage={`url(${COMMON_WEB_PATH}/theOne/ranking/ranking_${
                      index + 1
                    }_shine.png)`}
                    bgSize="100% 100%"
                    w={{
                      base: "80px",
                      md: "110px",
                    }}
                    h={{
                      base: "80px",
                      md: "110px",
                    }}
                    bgPos="center"
                    zIndex={10}
                  ></Box>
                  <Box
                    minW={{
                      base: "70px",
                      md: "90px",
                    }}
                    minH={{
                      base: "70px",
                      md: "90px",
                    }}
                    maxW={{
                      base: "70px",
                      md: "90px",
                    }}
                    maxH={{
                      base: "70px",
                      md: "90px",
                    }}
                    borderRadius={"100%"}
                    position="absolute"
                    top="12px"
                    right={{
                      base: "-27px",
                      md: "-45px",
                    }}
                    // zIndex={-1}
                    overflow="hidden"
                    border={`2px solid ${rank_config[index + 1]?.color}`}
                  >
                    <LazyLoadImage
                      // className={
                      //   "min-w-[90px] min-h-[90px] max-w-[90px] max-h-[90px] rounded-full"
                      // }
                      src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                        game_code,
                      )}.webp`}
                    />
                  </Box>
                </Box>
              </SplideSlide>
            );
          })}
        </Splide>
      </Box>
    </>
  );
};

export default TopGameBoard;
